// extracted by mini-css-extract-plugin
export var currencyInput = "_os-1";
export var currencySymbol = "_os-0";